var map = {
	"./andrews_logo.png": 665,
	"./carlisle_logo.png": 666,
	"./crane_logo.png": 667,
	"./demo_logo.png": 668,
	"./gmn_logo.png": 669,
	"./inventoryprod_logo.png": 670,
	"./keycompounding_logo.png": 671,
	"./kuslers_logo.png": 672,
	"./ordertrack_logo.png": 673,
	"./orion_logo.png": 674,
	"./skills_logo.png": 675,
	"./slayer_logo.png": 676,
	"./testCustomerInventory_logo.png": 677,
	"./testCustomerOrder_logo.png": 678,
	"./toolgauge_logo.png": 679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1476;